import { Create, useForm, useSelect } from "@refinedev/antd";
import { Form, Input, Select, Tag, Space, Row, Col } from "antd";
import { IResourceComponentsProps } from "@refinedev/core";
import { SafetyCertificateOutlined, SettingOutlined, LinkOutlined } from "@ant-design/icons";

import { ILicence, IShipco, ISubscription } from "interfaces";
import { FormSection, FormFieldGrid } from "components/form";

export const LicenceCreate: React.FC<IResourceComponentsProps> = () => {
  const {
    formProps,
    saveButtonProps,
    formLoading: isLoading,
  } = useForm<ILicence>({ redirect: "list" });

  const { selectProps: shipcoSelectProps } = useSelect<IShipco>({
    resource: "shipco",
    optionLabel: "registrationName",
    optionValue: "id",
    pagination: {
      mode: "server"
    }
  });

  const { selectProps: shipcoGroupSelectProps } = useSelect<IShipco>({
    resource: "shipco-group",
    optionLabel: "registrationName",
    optionValue: "id",
    pagination: {
      mode: "server"
    }
  });

  const { selectProps: subscriptionSelectProps } = useSelect<ISubscription>({
    resource: "subscription",
    optionLabel: "subscriptionName",
    optionValue: "id",
    pagination: {
      mode: "server"
    }
  });

  return (
    <Create
      breadcrumb={false}
      saveButtonProps={saveButtonProps}
      headerProps={{
        onBack: () => window.history.back(),
        subTitle: "setup new licence",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form {...formProps} layout="vertical">
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="Licence Details"
            subtitle="UKHO licence information"
            icon={<SafetyCertificateOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={2}>
              <Form.Item
                label="UKHO Licence"
                name="ukhoLicenceId"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Subscription"
                name={["subscription", "subscriptionName"]}
              >
                <Select {...subscriptionSelectProps} />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>

          <Row gutter={24}>
            <Col xs={24} lg={12}>
              <FormSection
                title="Delivery Settings"
                subtitle="Invoice and order configuration"
                icon={<SettingOutlined />}
              >
                <FormFieldGrid columns={1}>
                  <Form.Item label="Invoice Delivery" name="invoiceDelivery">
                    <Select
                      defaultValue="email"
                      options={[
                        { label: "Email", value: "email" },
                        { label: "Download", value: "download" },
                        { label: "Both", value: "both" },
                      ]}
                    />
                  </Form.Item>
                  <Form.Item label="Purchase Order Required?" name="purchaseOrderReqd">
                    <Select
                      defaultValue="required"
                      options={[
                        { label: "Not Required", value: "not required" },
                        { label: "Required", value: "required" },
                      ]}
                    />
                  </Form.Item>
                </FormFieldGrid>
              </FormSection>
            </Col>

            <Col xs={24} lg={12}>
              <FormSection
                title="Company Association"
                subtitle="Link to shipping company"
                icon={<LinkOutlined />}
              >
                <Form.Item label="Shipco" name={["shipco", "id"]}>
                  <Select {...shipcoSelectProps} />
                </Form.Item>
                <Form.Item label="Shipco Group" name={["shipcoGroup", "id"]}>
                  <Select {...shipcoGroupSelectProps} />
                </Form.Item>
              </FormSection>
            </Col>
          </Row>
        </Space>
      </Form>
    </Create>
  );
};
